// lib/auth.ts
import { createRumahPendidikanAuthConfig } from '@rumah-pendidikan/auth/react'

export const auth = createRumahPendidikanAuthConfig({
  appBaseUrl: process.env.NEXT_PUBLIC_APP_ORIGIN || 'http://localhost:3000',
  oidc: {
    issuer: process.env.NEXT_PUBLIC_OIDC_AUTHORITY!,
  },
})
